import axios from "axios";

export const state = {
    interestpayouts: [],
};

export const getters = {
    interestpayouts: state => state.interestpayouts,
};

export const mutations = {
    setPayouts(state, newValue) {
        state.interestpayouts = newValue
    },
};

export const actions = {
    async fetchInterestPayouts({ commit }) {
        await axios.get('/interestpayouts').then(res => {
            commit('setPayouts', res.data.payouts)
        })
    },
    async filterInterestPayouts({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterinterestpayouts";
        await axios.post(url, formData).then((response) => {
            commit('setPayouts', response.data.payouts)
        })
    },
};
